/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum AprilFoolType {
    AprilFools = 'AprilFools',
    AprilDream = 'AprilDream',
    NormalRelease = 'NormalRelease'
}

export function AprilFoolTypeFromJSON(json: any): AprilFoolType {
    return AprilFoolTypeFromJSONTyped(json, false);
}

export function AprilFoolTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AprilFoolType {
    return json as AprilFoolType;
}

export function AprilFoolTypeToJSON(value?: AprilFoolType | null): any {
    return value as any;
}

